import { render, staticRenderFns } from "./Investee.vue?vue&type=template&id=0393412d&scoped=true&"
import script from "./Investee.vue?vue&type=script&lang=js&"
export * from "./Investee.vue?vue&type=script&lang=js&"
import style0 from "./Investee.vue?vue&type=style&index=0&id=0393412d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0393412d",
  null
  
)

export default component.exports